import { SvgIcon } from '@mui/material';
import React, { ReactElement } from 'react';

export interface CloseIconProps {
  strokeColor?: string;
}

export const CloseIcon = ({
  strokeColor = '#000',
}: CloseIconProps): ReactElement => (
  <SvgIcon
    style={{ fontSize: '1em' }}
    width="21.5"
    height="21.5"
    viewBox="0 0 21.5 21.5"
  >
    <g transform="translate(0.75 0.75)">
      <path
        d="M24.5,14.5a10,10,0,1,0-10,10A10,10,0,0,0,24.5,14.5Z"
        transform="translate(-4.5 -4.5)"
        fill="none"
        stroke={strokeColor}
        strokeMiterlimit="10"
        strokeWidth="1.5"
      />
      <path
        d="M20.167,20.167,13.5,13.5"
        transform="translate(-6.833 -6.833)"
        fill="none"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M13.5,20.167,20.167,13.5"
        transform="translate(-6.833 -6.833)"
        fill="none"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </g>
  </SvgIcon>
);
